









import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component
export default class LedianToLogin extends Vue {
  @Prop({ required: true })
  /**
   * @see SignupPageProps.loginLink
   */
  readonly loginLink: string
}
